import {CustomerFeedbackHttpClient} from "../../http-clients/CustomerFeedbackHttpClient";
import {renderImagePopup} from "../ImagePopup";

export class CustomerFeedbackContainer {
    constructor(container) {
        this.state = {
            currentPage: 1,
            fetching: false,
        };

        this.container = container;

        this
            .initItems()
            .bindPaginationHandler()
        ;
    }

    initItems() {
        const items = this.container.querySelectorAll('.customer-feedback-item');

        for (let item of items) {
            const object = new CustomerFeedbackItem();
            object.bindImagePopupHandler(item);
        }

        return this;
    }

    bindPaginationHandler() {
        const id = this.container.getAttribute('data-id');
        const dataType = this.container.getAttribute('data-type');

        const hasDataAttributes = id && dataType;
        const button = this.container.querySelector('.load-more-feedback');

        if (
            !button ||
            !hasDataAttributes
        ) {
            return this;
        }

        button.addEventListener('click', event => {
            event.preventDefault();

            if (this.state.fetching) {
                return;
            }

            this.loadMoreFeedbackAction()
        });

        return this;
    }

    async loadMoreFeedbackAction() {
        this.state.currentPage++;
        this.state.fetching = true;

        const loadButton = this.container.querySelector('.load-more-feedback');
        const listContainer = this.container.querySelector('.customer-feedback-content');
        const feedbackType = this.container.getAttribute('data-type');

        const loadButtonContent = loadButton.querySelector('.button-title');
        loadButtonContent.textContent = 'Trwa wczytywanie...';

        const getData = page => {
            const client = new CustomerFeedbackHttpClient();
            const ids = this.container.getAttribute('data-id').split(',');

            return client.getFeedbackByProducts(ids, page);
        };

        try {
            const {
                items,
                maxPage,
            } = await getData(this.state.currentPage);

            for (let item of items) {
                const feedbackItem = new CustomerFeedbackItem(feedbackType);

                listContainer.appendChild(feedbackItem.render(item));
            }

            if (maxPage === this.state.currentPage) {
                loadButton.remove();
            } else {
                loadButtonContent.textContent = 'Zobacz więcej opinii';
            }
        } catch (error) {
            loadButtonContent.textContent = 'Zobacz więcej opinii';
            toast.error('Wystąpił błąd podczas pobierania opinii');

            return;
        }

        this.state.fetching = false;
    }

}

export class CustomerFeedbackItem {
    constructor(feedbackType) {
        this.feedbackType = feedbackType;
    }

    render(itemModel) {
        const wrapper = document.createElement("div");
        wrapper.classList.add('customer-feedback-item');

        const isCategoryFeedback = this.feedbackType === 'category';

        const content = `
                <div class="header">
                    ${isCategoryFeedback 
                        ? `<a class="product-name" href="${itemModel.product.url}">${itemModel.product.name}</a>`
                        : `<span class="product-name">${itemModel.user.name}</span>`
                    }
                    <span class="customer-name" ${!isCategoryFeedback ? ' style="display:none"' : ''}>
                        ${isCategoryFeedback ? itemModel.user.name : ''}
                    </span>
                    <div class="separator"></div>
                    <span class="stars">
                        ${Array(itemModel.rate.max).fill().map((item, index) => {
                            if (1 + index > itemModel.rate.value) {
                                return `<i class="icon icon-star"></i>`;
                            }
                            return `<i class="icon icon-star-filled"></i>`;
                        }).join('')}
                    </span>
                    <span class="date-time">
                        ${itemModel.createdAt}
                    </span>
                </div>
                <p class="content">
                    ${itemModel.description}
                </p>
                <div class="gallery">
                    ${itemModel.images.map(url => {
                        return `
                           <a href="${url}">
                                <img src="${url}">
                            </a>
                        `   
                    }).join('')}
                </div>
                ${itemModel.signature
                    ? `<div class="feedback-reply">
                        <div class="feedback-reply-content">
                            <div class="feedback-reply-signature">
                                <strong>${itemModel.signature}</strong>
                            </div>
                            <div class="feedback-reply-text">
                                ${itemModel.reply}
                            </div>
                        </div>
                      </div>`
                    : ``
                }

        `;

        wrapper.innerHTML = content;

        this.bindImagePopupHandler(wrapper);

        return wrapper
    }

    bindImagePopupHandler(element) {
        const anchors = element.querySelectorAll('.gallery a');

        for (let anchor of anchors) {
            const imageUrl = anchor.getAttribute('href');

            anchor.addEventListener('click', event => {
                event.preventDefault();
                renderImagePopup(imageUrl)
            });
        }

        return this;
    }
}
